module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      bgblack: _vm.introBG
    }
  }, [_c('transition', {
    attrs: {
      "name": "slideUp"
    }
  }, [(_vm.intro) ? _c('div', {
    staticClass: "welcome",
    attrs: {
      "aria-label": "Welcome Screen, press enter key to enter the site."
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "screen"
  }, [_c('img', {
    staticClass: "cover",
    attrs: {
      "src": _vm.introImage
    }
  })]), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "static/logos/caam_logo_white.svg",
      "alt": "Image of Caam Logo which spells CAAM."
    }
  })]), _c('button', {
    staticClass: "next",
    attrs: {
      "role": "Button",
      "aria-label": "Click or press enter to enter the site."
    },
    on: {
      "click": _vm.enter
    }
  }, [_c('img', {
    attrs: {
      "src": "static/icons/arrow_down_white.svg",
      "alt": "Downfacing Triangle"
    }
  })])]) : _vm._e()])], 1) : _vm._e()]), _c('transition', {
    attrs: {
      "name": "slideUpOffset"
    }
  }, [(!_vm.intro) ? _c('div', {
    staticClass: "main"
  }, [_c('top-nav', {
    attrs: {
      "headerColor": "black"
    }
  }), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "home"
  }, [_c('home-exhibition', {
    key: "first",
    attrs: {
      "exhibition": _vm.exhibitionFirst
    }
  }), (!_vm.introBG) ? _c('div', [_vm._l((_vm.exhibitions), function(exhibition) {
    return _c('home-exhibition', {
      key: _vm.title(exhibition),
      attrs: {
        "exhibition": exhibition
      }
    })
  }), (_vm.programs.length > 0) ? _c('home-events', {
    attrs: {
      "programs": _vm.programs
    }
  }) : _vm._e(), _c('home-explore', {
    attrs: {
      "explore": _vm.explore
    }
  })], 2) : _vm._e()], 1) : _vm._e()]), (!_vm.introBG) ? _c('bottom-nav', {
    attrs: {
      "footerColor": "black"
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf08904"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 238
// module chunks = 1